import { SELECT_LOGIN } from './typeConstants';

export const selectLogin= (data) => ({
    type: SELECT_LOGIN,
    data,
});